/* eslint-disable import/no-mutable-exports */
let ENV;
switch (window.location.hostname) {
  case 'app.novotalk.com':
    ENV = 'prod';
    break;

  case 'gt-nvnew-stg-client.novotalk.com':
    ENV = 'stg';
    break;

  case 'local.novotalk.com':
    ENV = 'local';
    break;

  case 'localhost':
    ENV = 'local';
    break;

  default:
    ENV = 'prod';
    break;
}
const API_URL = process.env.REACT_APP_API_URL
const WEB_URL = process.env.REACT_APP_WEB_URL
const REACT_APP_STRIPE_TOKENS = `${process.env.REACT_APP_STRIPE_TOKENS}`
const IS_MVP = process.env.REACT_APP_IS_MVP;
const ZOHO_ASAP_APP_URL = process.env.REACT_APP_ZOHO_ASAP_APP_URL;

export const AUTH_ENDPOINTS = {
  SIGN_IN: '/signin',
  SIGN_UP: '/signup',
  VALIDATE: '/validate',
  GET_UID: '/getUID',
  USER_ROLES_ENUM: '/rolesEnum',
  PROPERTIES: '/properties',
  PASSWORD_CHANGED_AT: '/passwordChangedAt',
  CONFIRM_FORGOT_PASSWORD: '/confirmForgotPassword',
};

export const CLOUD_ENDPOINTS = {
  UPLOAD_MEDIA: '/uploadMedia',
  UPLOAD_CHAT_MEDIA: '/uploadChatMedia',
};

export const CHAT_ENDPOINTS = {
  INITIATE_CHAT_V2: '/initiateChatV2',
  GET_CHAT_INFO_V2: '/getChatInfoV2',
  END_CHAT_V2: '/endChatV2',
  START_ACTIVITY_SESSION: '/startActivitySession',
  START_ACTIVITY_ARCHIVE: '/startActivityArchive',
  STOP_ACTIVITY_ARCHIVE: '/stopActivityArchive',
  END_ACTIVITY_SESSION: '/endActivitySession',
};

export const TIME_TRACKING_ENDPOINTS = {
  CREATE_TIME_TRACKING: '/createTimeTracking',
  UPDATE_TIME_TRACKING: '/updateTimeTracking',
};

export const BILLING_ENDPOINTS = {
  SUBSCRIBE: '/subscribe',
  CANCEL_SUBSCRIPTION: '/cancelSubscription',
};

let GRAPHQL_SERVER = `${API_URL}/graphql/graphql`;
let AUTH_SERVER = `${API_URL}/auth`;
let CLOUD_SERVER = `${API_URL}/cloud`;
let SESSION_SERVER = `${API_URL}`;
let OLD_API = `${API_URL}/api`;
let REACT_APP_SERVER_URL = API_URL;
let WEB_CLIENT = WEB_URL;
let EVENT_LOGGER_SERVER = `${API_URL}/eventLogger/`;
let CHAT_SERVER = `${API_URL}/chat`;
let BILLING_SERVER = `${API_URL}/billing`;
let TIME_TRACKING_SERVER = `${API_URL}/timeTracking`;
let STRIPE_TOKEN = REACT_APP_STRIPE_TOKENS;

if (process.env.REACT_APP_IS_LOCAL) {

  GRAPHQL_SERVER = `${API_URL}:3004/graphql`;
  AUTH_SERVER = `${API_URL}:3005`;
  CLOUD_SERVER = `${API_URL}:3006`;
  SESSION_SERVER = `${API_URL}:3007`;
  OLD_API = `${API_URL}/api`;
  REACT_APP_SERVER_URL = API_URL;
  WEB_CLIENT = WEB_URL;
  EVENT_LOGGER_SERVER = `${API_URL}:3030`;
  CHAT_SERVER = `${API_URL}:3008`;
  BILLING_SERVER = `${API_URL}:3009`;
  TIME_TRACKING_SERVER = `${API_URL}:3019`;
  STRIPE_TOKEN = REACT_APP_STRIPE_TOKENS;
}

export const ENVIRONMENT = ENV;
export {
  GRAPHQL_SERVER,
  AUTH_SERVER,
  CLOUD_SERVER,
  SESSION_SERVER,
  OLD_API,
  REACT_APP_SERVER_URL,
  WEB_CLIENT,
  EVENT_LOGGER_SERVER,
  CHAT_SERVER,
  BILLING_SERVER,
  TIME_TRACKING_SERVER,
  STRIPE_TOKEN,
  ZOHO_ASAP_APP_URL,
  IS_MVP
};
